module.exports = __webpack_public_path__ + "img/marker-yellow.c4bf0533.svg";